import { render } from "./Tabs.vue?vue&type=template&id=938cd8c2"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "938cd8c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('938cd8c2', __exports__)) {
    console.log('reload')
    api.reload('938cd8c2', __exports__)
  }
  
  module.hot.accept("./Tabs.vue?vue&type=template&id=938cd8c2", () => {
    console.log('re-render')
    api.rerender('938cd8c2', render)
  })

}


export default __exports__